import React from 'react';
import { graphql } from 'gatsby';

import SectionItemContentText from '../../../../components/Section/SectionItems/SectionItemContentText';
import { normalizeTextAlign } from '../../utils';

// Types
import { SectionItemContentTextContainerFragment } from './__generated__/SectionItemContentTextContainerFragment';
import { SectionWidth } from '../../../../../types/sections';

export const fragment = graphql`
  fragment SectionItemContentTextContainerFragment on CMS_Section {
    text
    textAlign
    textColor
  }
`;

type Props = {
  contentPositionY: string;
  hasBackgroundImage: boolean;
  section: SectionItemContentTextContainerFragment;
  sectionWidth: SectionWidth;
};

const SectionItemContentTextContainer = ({ contentPositionY, hasBackgroundImage, section, sectionWidth }: Props) => {
  const text = section.text;

  if (typeof text !== 'string') {
    return null;
  }

  const textAlign = normalizeTextAlign(section.textAlign);
  const textColor = section.textColor;

  return (
    <SectionItemContentText
      contentPositionY={contentPositionY}
      hasBackgroundImage={hasBackgroundImage}
      sectionWidth={sectionWidth}
      text={text}
      textAlign={textAlign}
      textColor={textColor}
    />
  );
};

export default SectionItemContentTextContainer;
